<template id="bs-modal">
  <div
    class="modal fade"
    id="firstStart"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <!--div class="modal-body text-center"-->
        <div class="card text-center">
          <img src="img/welcome.jpg" class="card-img-top" alt="img/welcome.jpg">
          <div class="card-body">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
            <h5 class="card-title">Hallo!</h5>
            <p class="card-text">Indie42.de ist Dein Rss-Reader.</p>
            <p class="card-text">Noch nicht ganz perfekt, daher verzeiht kleine Fehler.</p>
            <p
              class="card-text"
            >Zum Start habe ich Dir ein paar interessante Feeds zusammengestellt.</p>
            <p class="card-text">
              Eigene Feeds kannst Du mit dem Astronauten
              <router-link to="/user" data-dismiss="modal">
                <i class="fas fa-user-astronaut"/>
              </router-link> verwalten.
            </p>

            <button type="button" class="btn btn-primary" data-dismiss="modal">Schliessen</button>
          </div>
        </div>
        <!--/div-->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FirstStart",
  methods: {
    doSend: function() {
      var event = new CustomEvent("vue2html");
      document.dispatchEvent(event);
    }
  },
  mounted() {
    this.doSend();
  }
};
</script>

<style scoped>
a.test {
  color: #ffffff;
}
